export default "__VITE_ASSET__6akbOFYV__"